import { Avatar, Box, Button, Dialog, DialogContent, Grid, Hidden, IconButton, Menu, MenuItem, SelectChangeEvent, Skeleton, SxProps, Theme, Typography } from "@mui/material";
import { CommonLayout } from "../commonComponents";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import BreadCrum from "../../lib/BreadCrum";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux-store/reducers";
import { useState, useEffect } from "react";
import { AddRemoveFamilyMemberRes, FamilyDetailsData, GetFamilyAssetAllocationRes, GetFamilyBenchmarkPerformanceRes, GetFamilyDashboardRes, GetFamilyDetailsResponseBody, SendFamilyOtpRes, VerifyFamilyOtpRes } from "../../redux-store/types/investorProfile";
import { getFamilyAssetAllocation, getFamilyBenchamrkPerformance, getFamilyDashboard, getFamilyDetails, addRemoveFamilyMember } from "../../redux-store/actions/investorProfile";
import dayjs from "dayjs";
import { formatCurrency, maskInfo } from "../../utils/utilityFunctions";
import PieChartComponent from "../investorOverview/directEquity/directEquityOverview/PieChartComponent";
import FamilyPieChartComponent from "../investorOverview/common/FamilyPieChart";
import { NO_DATA_AVAILABLE, USER_ROLES } from "../../utils/constant";
import { PlusIcon } from "../../assets/SvgIcons";
import CustomDropdown from "../investorOverview/directEquity/directEquityOverview/CustomDropdown";
import CustomNavChart from "../dashboard/chart/CustomNavChart";
import CustomePieChart from "../dashboard/chart/CustomePieChart";
import MainFamilyInfo from "./MainFamilyInfo";
import OTPForm from "../../lib/formik/OtpForm";
import { setViewAsFamilyId } from "../../redux-store/actions/id";
import { ErrorText } from "../dashboard/chart/CustomeLineChart";
import { FamilyBenchmarkChart } from "./FamilyBenchmarkChart";
import { sendFamilyOtp, verifyFamilyOtp } from "../../redux-store/actions/investorProfile";
import { clearSelectedPortfolioObj, storeSelectedPortfolio } from "../../redux-store/actions/portfolioFilter";
import { showError } from "../../redux-store/actions/auth";

export interface navigationData {
    clientCode?: string;
    familyName?: string;
    accountFilter?: number;
    familyId?: string;
    familyHeadName?: string;
}


const FamilyInfo = ({
    columnWidth = { xs: 4 },
    personName,
    isAdmin,
    personDesignation,
    investmentValue,
    currentValue,
    overallReturns,
    irr,
    loading,
    handleNavigation,
    clientCode,
    showRemoveIcon = false,
    onRemoveMember,
    isRemove = false,
    isRmLoggedIn = false,
}: {
    columnWidth?: { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
    personName: string;
    isAdmin?: boolean;
    personDesignation: string | null;
    investmentValue: number;
    currentValue: number;
    overallReturns: number;
    irr: number;
    loading: boolean,
    handleNavigation?: (clientCode: string, investorName: string) => void,
    clientCode?: string;
    showRemoveIcon?: boolean;
    isRemove?: boolean;
    isRmLoggedIn?: boolean;
    onRemoveMember?: (clientCode: string, memberName: string) => void;
}): JSX.Element => {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

    const canRemove = Boolean(showRemoveIcon && clientCode);
    const handleOpenMenu = (e: any) => {
        e.stopPropagation();
        setMenuAnchorEl(e.currentTarget);
    };
    const handleCloseMenu = () => setMenuAnchorEl(null);
    const handleRemove = () => {
        if (!canRemove || !clientCode) return;
        onRemoveMember?.(clientCode, personName);
        handleCloseMenu();
    };
    return (
        <>
            {!loading && (
                <Grid
                    xs={columnWidth?.xs ?? false}
                    sm={columnWidth?.sm ?? false}
                    md={columnWidth?.md ?? false}
                    lg={columnWidth?.lg ?? false}
                    xl={columnWidth?.xl ?? false}
                    item
                    container
                    sx={(theme: Theme) => ({
                        backgroundColor: theme.palette.common.white,
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.white}0D`,
                        borderRadius: "12px",
                        padding: "24px",
                        flexDirection: "column"
                    })}
                >
                    <Grid
                        item
                        container
                        sx={{
                            alignItems: "center",
                            flexWrap: "nowrap",
                            columnGap: "12px",
                            paddingBottom: "20px"
                        }}
                    >
                        <Grid item>
                            <Avatar
                                sx={(theme: Theme) => ({
                                    borderRadius: "12px",
                                    backgroundColor: theme.palette.grey[50],
                                    padding: { xs: "15px", sm: "18px", md: "20px", lg: "25px" },
                                    boxShadow: `0px 3.5px 5.5px 0px ${theme.palette.common.black}05`
                                })}
                            >
                                <Typography
                                    variant="body_600"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.primary[500],
                                        lineHeight: "22.5px"
                                    })}
                                >
                                    {personName?.slice(0, 2).toUpperCase()}
                                </Typography>
                            </Avatar>
                        </Grid>
                        <Grid
                            item
                            container
                            xs={10}
                            sx={{
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                columnGap: "10px"
                            }}
                        >
                            <Grid
                                item
                                container
                                sx={{
                                    flexDirection: "column",
                                    flexWrap: "nowrap",
                                    rowGap: "3px",
                                    minWidth: 0,
                                    flex: 1
                                }}
                            >
                                <Grid
                                    xs
                                    item
                                    container
                                    sx={{
                                        columnGap: "5px",
                                        flexWrap: "wrap",
                                        alignItems: "center"
                                    }}
                                >
                                    <Grid item sx={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}>
                                        <Typography
                                            variant="body_600"
                                            onClick={() => handleNavigation ? handleNavigation(clientCode as string, personName) : null}
                                            sx={(theme: Theme) => ({
                                                color: theme.palette.primary[500],
                                                lineHeight: "22.5px",
                                                cursor: "pointer"
                                            })}
                                        >
                                            {personName}
                                        </Typography>
                                        {isAdmin && (
                                            <Grid
                                                item
                                                sx={(theme: Theme) => ({
                                                    borderRadius: "8px",
                                                    padding: "3px 10px",
                                                    backgroundColor: theme.palette.grey[50]
                                                })}
                                            >
                                                <Typography
                                                    variant="overline_400"
                                                    sx={(theme: Theme) => ({
                                                        fontWeight: 500,
                                                        lineHeight: "15px",
                                                        letterSpacing: "0.02px",
                                                        color: theme.palette.primary[500]
                                                    })}
                                                >
                                                    Admin
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid xs item>
                                    <Typography
                                        variant="subtitle_500"
                                        sx={(theme: Theme) => ({
                                            lineHeight: "17.5px",
                                            letterSpacing: "0.02px",
                                            color: theme.palette.text.secondary
                                        })}
                                    >
                                        {personDesignation}
                                    </Typography>
                                </Grid>
                            </Grid>
                            {canRemove && (
                                <Grid item sx={{ pt: "2px" }}>
                                    <IconButton
                                        aria-label="remove-member"
                                        onClick={handleOpenMenu}
                                        disabled={!isRmLoggedIn}
                                        size="small"
                                        sx={(theme: Theme) => ({
                                            padding: 0,
                                            color: theme.palette.text.secondary,
                                             '&:disabled': {
                                                opacity: 0.5,
                                                cursor: "not-allowed",
                                                pointerEvents: "auto",
                                            }
                                        })}
                                    >
                                        <MoreHoriz fontSize="small" />
                                    </IconButton>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        container
                        sx={(theme: Theme) => ({
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: 'nowrap',
                            paddingBottom: "12px",
                            paddingTop: "12px",
                            borderBottom: `0.5px solid ${theme.palette.customColors.lavender}`
                        })}
                    >
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle_500"
                                sx={(theme: Theme) => ({
                                    textAlign: "left",
                                    lineHeight: "17.5px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.customColors.greyFourty
                                })}
                            >
                                Investment Value
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle_500"
                                sx={(theme: Theme) => ({
                                    textAlign: "right",
                                    lineHeight: "17.5px",
                                    letterSpacing: "0.04px",
                                    color: theme.palette.customColors.codGrey
                                })}
                            >
                                {formatCurrency({ value: investmentValue, locale, currencyCode })}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        container
                        sx={(theme: Theme) => ({
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: 'nowrap',
                            paddingBottom: "12px",
                            paddingTop: "12px",
                            borderBottom: `0.5px solid ${theme.palette.customColors.lavender}`
                        })}
                    >
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle_500"
                                sx={(theme: Theme) => ({
                                    textAlign: "left",
                                    lineHeight: "17.5px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.customColors.greyFourty
                                })}
                            >
                                Current Value
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle_500"
                                sx={(theme: Theme) => ({
                                    textAlign: "right",
                                    lineHeight: "17.5px",
                                    letterSpacing: "0.04px",
                                    color: theme.palette.customColors.codGrey
                                })}
                            >
                                {formatCurrency({ value: currentValue, locale, currencyCode })}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        container
                        sx={(theme: Theme) => ({
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: 'nowrap',
                            paddingBottom: "12px",
                            paddingTop: "12px",
                            borderBottom: `0.5px solid ${theme.palette.customColors.lavender}`
                        })}
                    >
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle_500"
                                sx={(theme: Theme) => ({
                                    textAlign: "left",
                                    lineHeight: "17.5px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.customColors.greyFourty
                                })}
                            >
                                Overall Returns
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle_500"
                                sx={(theme: Theme) => ({
                                    textAlign: "right",
                                    lineHeight: "17.5px",
                                    letterSpacing: "0.04px",
                                    color: overallReturns < 0 ? theme.palette.error[500] : theme.palette.success[500]
                                })}
                            >
                                {formatCurrency({ value: overallReturns, locale, currencyCode })}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        container
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: 'nowrap',
                            paddingTop: "12px",
                        }}
                    >
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle_500"
                                sx={(theme: Theme) => ({
                                    textAlign: "left",
                                    lineHeight: "17.5px",
                                    letterSpacing: "0.02px",
                                    color: theme.palette.customColors.greyFourty
                                })}
                            >
                                IRR
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                variant="subtitle_500"
                                sx={(theme: Theme) => ({
                                    textAlign: "right",
                                    lineHeight: "17.5px",
                                    letterSpacing: "0.04px",
                                    color: irr < 0 ? theme.palette.error[500] : theme.palette.success[500]
                                })}
                            >
                                {irr?.toFixed(1)}%
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            )}
            {loading && (
                <Grid
                    {...{ columnWidth }}
                    item
                    container
                    sx={(theme: Theme) => ({
                        backgroundColor: theme.palette.common.white,
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.white}0D`,
                        borderRadius: "12px",
                        padding: "24px",
                        flexDirection: "column"
                    })}
                >
                    <Grid
                        item
                        container
                        sx={{
                            alignItems: "center",
                            flexWrap: "nowrap",
                            columnGap: "12px",
                            paddingBottom: "20px"
                        }}
                    >
                        <Grid item>
                            <Skeleton animation="wave" variant="circular" sx={{ width: "50px", height: "50px" }} />
                        </Grid>
                        <Grid
                            item
                            container
                            xs={10}
                            sx={{
                                flexDirection: "column",
                                flexWrap: "nowrap",
                                rowGap: "3px"
                            }}
                        >
                            <Grid
                                xs
                                item
                                container
                                sx={{
                                    columnGap: "5px",
                                    flexWrap: "wrap",
                                    alignItems: "center"
                                }}
                            >
                                <Grid item sx={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}>
                                    <Skeleton animation="wave" width={'80px'} />
                                    {isAdmin && (
                                        <Grid
                                            item
                                            sx={(theme: Theme) => ({
                                                borderRadius: "8px",
                                                padding: "3px 10px",
                                                backgroundColor: theme.palette.grey[50]
                                            })}
                                        >
                                            <Skeleton animation="wave" width={'50px'} />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid xs item>
                                <Skeleton animation="wave" width={'50%'} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        container
                        sx={(theme: Theme) => ({
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: 'nowrap',
                            paddingBottom: "12px",
                            paddingTop: "12px",
                            borderBottom: `0.5px solid ${theme.palette.customColors.lavender}`
                        })}
                    >
                        <Grid item xs={6}>
                            <Skeleton animation="wave" width={'70%'} />
                        </Grid>
                        <Grid item xs={6}>
                            <Skeleton animation="wave" />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        container
                        sx={(theme: Theme) => ({
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: 'nowrap',
                            paddingBottom: "12px",
                            paddingTop: "12px",
                            borderBottom: `0.5px solid ${theme.palette.customColors.lavender}`
                        })}
                    >
                        <Grid item xs={6}>
                            <Skeleton animation="wave" width={'70%'} />
                        </Grid>
                        <Grid item xs={6}>
                            <Skeleton animation="wave" />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        container
                        sx={(theme: Theme) => ({
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: 'nowrap',
                            paddingBottom: "12px",
                            paddingTop: "12px",
                            borderBottom: `0.5px solid ${theme.palette.customColors.lavender}`
                        })}
                    >
                        <Grid item xs={6}>
                            <Skeleton animation="wave" width={'70%'} />
                        </Grid>
                        <Grid item xs={6}>
                            <Skeleton animation="wave" />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        container
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: 'nowrap',
                            paddingTop: "12px",
                        }}
                    >
                        <Grid item xs={6}>
                            <Skeleton animation="wave" width={'70%'} />
                        </Grid>
                        <Grid item xs={6}>
                            <Skeleton animation="wave" />
                        </Grid>
                    </Grid>
                </Grid>
            )}
            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleCloseMenu}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "12px",
                        }
                    }
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem
                    onClick={handleRemove}
                    disabled={!canRemove}
                    sx={(theme: Theme) => ({
                        color: theme.palette.text.secondary,
                        fontWeight: 500
                    })}
                >
                    {isRemove ? 'Removing...' : 'Remove'}
                </MenuItem>
            </Menu>
        </>
    )
}

export default function FamilyProfileDetails(): JSX.Element {
    const history = useHistory();
    const dispatch = useDispatch();

    const { pathname: pathName, state } = history.location;
    const navState = state as navigationData
    const { iwappRmId = "", familyId = "", familyMemberId = "" } = useSelector((state: RootStateType) => state.id)
    const { role = "" } = useSelector((state: RootStateType) => state.auth);
    const { businessDate } = useSelector((state: RootStateType) => state.navbarInfo)
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    const [memberToRemove, setMemberToRemove] = useState<{ clientCode: string; memberName: string } | null>(null);
    const [otpReference, setOtpReference] = useState<number | null>(null);
    const [familyData, setFamilyData] = useState<FamilyDetailsData>({} as FamilyDetailsData)
    const [selInvOption, setSelInvOption] = useState<string>('Internal');
    const [isFamilyDataLoading, setFamilyDataLoading] = useState<boolean>(false)
    const [open, setOpen] = useState(false);
    const [apiError, setApiError] = useState<boolean>(true);
    const [isSuccess, setIsSuccess] = useState<boolean>(true);
    const [otpDialogOpen, setOtpDialogOpen] = useState<boolean>(false);
    const [otpMessage, setOtpMessage] = useState<string>('');
    const [familyAssetLoading, setFamilyAssetLoading] = useState<boolean>(false);
    const [familyAssetData, setFamilyAssetData] = useState<GetFamilyAssetAllocationRes>({} as GetFamilyAssetAllocationRes)
    const [familyBenchmarkLoading, setFamilyBenchmarkLoading] = useState<boolean>(false);
    const [familyBenchmarkData, setFamilyBenchmarkData] = useState<GetFamilyBenchmarkPerformanceRes>({} as GetFamilyBenchmarkPerformanceRes);
    const [familyMembersData, setFamilyMembersData] = useState<GetFamilyDashboardRes>({} as GetFamilyDashboardRes)
    const [isRemove, setIsRemove] = useState<boolean>(false);
    const isRmLoggedIn = familyData?.relationManager  === iwappRmId;

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             setFamilyDataLoading(true)

    //             const response = await (dispatch(getFamilyDetails({
    //                 familyName: navState?.familyName ?? "",
    //                 rmId: `${iwappRmId}`
    //             })) as unknown as Promise<GetFamilyDetailsResponseBody>)

    //             if (response?.isSuccess) {
    //                 const modifiedRes: FamilyDetailsData = {
    //                     ...response.result,
    //                     familyName: maskInfo(response.result?.familyName),
    //                     familyMembers: response.result?.familyMembers?.map((item: any) => ({
    //                         ...item,
    //                         name: maskInfo(item.name)
    //                     })),
    //                     familyDistribution: {
    //                         ...response.result?.familyDistribution,
    //                         labelData: response.result?.familyDistribution?.labelData?.map((item: any) => ({
    //                             ...item,
    //                             label: maskInfo(item.label)
    //                         }))
    //                     }

    //                 }

    //                 // console.log('modifiedRes', modifiedRes)
    //                 setFamilyData(modifiedRes)
    //                 setApiError(false)
    //                 setIsSuccess(true)
    //             } else {
    //                 setApiError(true)
    //                 setIsSuccess(false)
    //             }


    //         } catch (error) {
    //             setApiError(true)
    //             setIsSuccess(false)
    //             console.log("Error: ", error)
    //         } finally {
    //             setFamilyDataLoading(false)
    //         }
    //     }


    //     fetchData()
    // }, [])



    const familyDashboardDetails = async ({
        level = "Internal"
    }: {
        level?: string
    } = {}) => {
        try {
            setFamilyDataLoading(true);
            const response = await (dispatch(getFamilyDashboard({
                rmId: `${iwappRmId}`,
                familyId: navState?.familyId || familyId,
                level
            })) as unknown as Promise<GetFamilyDashboardRes>);

            if (response?.isSuccess) {
                setFamilyMembersData(response)
                const modifiedFamilyRes = {
                    familyDistribution: response?.familyDistribution,
                    familyName: response?.result?.[0]?.familyName,
                    familyID: response?.result?.[0]?.familyID,
                    familyHead: response?.result?.[0]?.isFamilyHead,
                    familyHeadName: response?.result?.find((member: any) => member.isFamilyHead === 'Y')?.customerName || '',
                    relationManager: response?.result?.[0]?.relationManager || '',
                    marketValue: response?.result?.[0]?.familyMarketValue,
                    totalInvestment: response?.result?.[0]?.familyBookCost,
                    returns: response?.result?.[0]?.familyReturns,
                    irr: response?.result?.[0]?.familyReturnPercentage,
                    familyMembers: response?.result?.map((family) => ({
                        name: family?.customerName,
                        clientCode: family?.customer,
                        isAdmin: false,
                        relation: '',
                        investmentValue: 0,
                        currentValue: 0,
                        overallReturns: 0,
                        irr: 0
                    }))
                }

                setFamilyData(modifiedFamilyRes);
                setIsSuccess(true);
            }
        } catch (e) {
            console.error('error', e);
        } finally {
            setFamilyDataLoading(false);
        }
    }

    const fetchFamilyAssetAllocation = async ({
        level = "Internal"
    }: {
        level?: string;
    } = {}) => {
        try {
            setFamilyAssetLoading(true);
            const familyAssetRes = await (dispatch(getFamilyAssetAllocation({
                rmId: `${iwappRmId}`,
                familyId: navState?.familyId || familyId,
                level
            })) as unknown as Promise<GetFamilyAssetAllocationRes>);

            setFamilyAssetData(familyAssetRes);
        } catch (e) {
            console.error('Error', e);
        } finally {
            setFamilyAssetLoading(false);
        }
    }

    const fetchFamilyBenchmarkPerformance = async ({
        level = "Internal"
    }: {
        level?: string;
    } = {}) => {
        try {
            setFamilyBenchmarkLoading(true);
            const familyBenchmarkRes = await (dispatch(getFamilyBenchamrkPerformance({
                rmId: `${iwappRmId}`,
                familyId: navState?.familyId || familyId,
                level
            })) as unknown as Promise<GetFamilyBenchmarkPerformanceRes>);
            setFamilyBenchmarkData(familyBenchmarkRes);
            console.log('benchmark', familyBenchmarkRes);
        } catch (e) {
            console.error('Error', e);
        } finally {
            setFamilyBenchmarkLoading(false);
        }
    }

    const investmentDopdownOptions = [
        {
            label: 'Thrive Investments',
            value: 'Internal'
        },
        {
            label: 'External Investments',
            value: 'External'
        },
        {
            label: 'Overall Investments',
            value: 'All'
        },
    ]

    useEffect(() => {
        const fetchFamilyData = async () => {
            try {
                await Promise.allSettled([familyDashboardDetails(), fetchFamilyAssetAllocation(), fetchFamilyBenchmarkPerformance()]);
            }
            catch (e) {
                console.error('Error', e);
            }
        }
        fetchFamilyData();
    }, [])

    const initialRouter = pathName.split('/').filter((item) => item !== '')

    const rmRouterPath = [
        {
            name: 'Dashboard',
            path: '/dashboard',
            state: {
                accountFilter: navState?.accountFilter,
            }
        },
        {
            name: `${initialRouter[1]}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: navState?.clientCode
            }
        },
    ]

    const investorRouterPath = [
        {
            name: 'Dashboard',
            path: '/investor-dashboard'
        },
        {
            name: 'Family Dashboard',
            path: `/investor-family/family-profile/${initialRouter[2]}`
        }
    ];

    const handleClickEvent = async (clientCode: string, investorName: string) => {
        if (role === USER_ROLES.INVESTOR) {
            await dispatch(storeSelectedPortfolio({ label: '', value: '' }))
            await dispatch(clearSelectedPortfolioObj());
            await dispatch(setViewAsFamilyId(clientCode));
            history.push(`/investor-family/${investorName}`, {
                clientCode: clientCode,
                portfoiloId: "",
                applicationId: "",
            });
        }
        else {
            // await dispatch(storeSelectedPortfolio({ label: '', value: '' }))
            // await dispatch(clearSelectedPortfolioObj());
            history.push(`/investor-profile/${investorName}`, {
                clientCode: clientCode,
                portfoiloId: "",
            })
        }
    }


    const handleRemoveMember = async (clientCodeToRemove: string, memberName: string) => {
        setIsRemove(true);
        try {
            const response = await dispatch(sendFamilyOtp({
                clientCode: clientCodeToRemove,
                action: "REMOVE",
                isHeadOfFamily: false,
                familyName: familyData?.familyName ?? "",
                hofName: familyData?.familyHeadName ?? ""
            }) as unknown as Promise<SendFamilyOtpRes>);

            if (response?.isSuccess) {
                setMemberToRemove({ clientCode: clientCodeToRemove, memberName });
                setOtpReference(response.otpReference as number);
                setOtpMessage(response.message);
                setOtpDialogOpen(true);
            } else {
                dispatch(showError(response?.message ?? "Failed to Remove a family member"));
            }
        } catch (error) {
            dispatch(showError("An error occurred while sending OTP"));
        } finally {
            setIsRemove(false);
        }
    };

    const handleInvDropdownChange = async (value: string | number) => {
        setSelInvOption(`${value}`);

        await Promise.allSettled([familyDashboardDetails({ level: `${value}` }), fetchFamilyAssetAllocation({ level: `${value}` }), fetchFamilyBenchmarkPerformance({ level: `${value}` })]);
    }

    const handleCloseOtpDialog = () => {
        setOtpDialogOpen(false);
        setOtpMessage("");
        setMemberToRemove(null);
        setOtpReference(null);
    };
    const handleSubmit = async (otp: string) => {
        // const familyId = navState?.familyId || reduxFamilyId;
        if (!memberToRemove || !otpReference) return;

        try {
            const verifyResponse = await dispatch(verifyFamilyOtp({
                otp: otp,
                otpReference: otpReference
            }) as unknown as Promise<VerifyFamilyOtpRes>);

            if (verifyResponse?.isSuccess) {
                const response = await dispatch(addRemoveFamilyMember({
                    action: "REMOVE",
                    familyId: navState?.familyId || familyId,
                    familyMembers: [{
                        otpReference: otpReference,
                        clientCode: memberToRemove.clientCode,
                        isHeadOfFamily: false
                    }]
                }) as unknown as Promise<AddRemoveFamilyMemberRes>);

                if (response?.isSuccess) {
                    await familyDashboardDetails({ level: selInvOption });
                    await fetchFamilyAssetAllocation({ level: selInvOption });
                    await fetchFamilyBenchmarkPerformance({ level: selInvOption });
                    handleCloseOtpDialog();
                } else {
                    setOtpMessage(response?.message);
                }
            } else {
                setOtpMessage(verifyResponse?.message);
            }
        } catch (error) {
            console.error("Error removing member:", error);
            setOtpMessage("An error occurred while removing the member");
        }
    };

    const handleResendOtp = async () => {
        if (!memberToRemove) return;

        try {
            const response = await dispatch(sendFamilyOtp({
                clientCode: memberToRemove.clientCode,
                action: "REMOVE",
                isHeadOfFamily: false,
                familyName: familyData?.familyName ?? "",
                hofName: familyData?.familyHeadName ?? ""
            }) as unknown as Promise<SendFamilyOtpRes>);

            if (response?.isSuccess) {
                setOtpReference(response.otpReference as number);
                setOtpMessage("OTP resent successfully");
            } else {
                setOtpMessage(response?.message || "Failed to resend OTP");
            }
        } catch (error) {
            console.error("Error resending OTP:", error);
            setOtpMessage("An error occurred while resending OTP");
        }
    };

    const handleAddMemberClick = () => {
        if (role === USER_ROLES.INVESTOR) {
            history.push("/investor-family/addFamilyMember", {
                obj: familyData,
                fromFamilyProfile: true,
            })
        }
        else {
            history.push("/family/addFamilyMember", {
                obj: familyData, 
                fromFamilyProfile: true,
            })
        }
    }

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 2 }}>
                <BreadCrum array={role === USER_ROLES.INVESTOR ? investorRouterPath : rmRouterPath} />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '0.5rem' }}>
                    {isFamilyDataLoading ? (
                        <>
                            <Skeleton
                                variant="rectangular"
                                width={200}
                                height={20}
                                sx={{ borderRadius: '0.2rem' }}
                                animation="wave"
                            />
                            <Skeleton
                                variant="rectangular"
                                width={120}
                                height={36}
                                sx={{ borderRadius: '0.2rem' }}
                                animation="wave"
                            />
                        </>
                    ) : (
                        <>
                            <CustomDropdown
                                isLoading={isFamilyDataLoading}
                                selectedValue={selInvOption}
                                handleValueChange={handleInvDropdownChange}
                                dropdownOptions={investmentDopdownOptions}
                            />
                            <Button sx={(theme: Theme) => ({
                                background: theme.palette.primary[500],
                                borderRadius: '0.2rem',
                                width: 'fit-content',
                                padding: '0.5rem',
                                gap: '0.35rem',
                                '&:hover': {
                                    backgroundColor: theme.palette.primary[500]
                                },
                               '&:disabled': {
                                    backgroundColor: theme.palette.grey[500],
                                    cursor: "not-allowed",
                                    pointerEvents: 'auto',
                                    color: theme.palette.grey[300]
                                }
                            })}
                                onClick={handleAddMemberClick}
                                disabled={!isRmLoggedIn}
                            >
                                <PlusIcon />
                                <Typography variant="body_500" sx={(theme: Theme) => ({
                                    color: theme.palette.textDark.primary,
                                })}>Add  Member</Typography>
                            </Button>
                        </>
                    )}
                </Box>
            </Box>

            <Grid container spacing={{ xs: 2, sm: 3, md: 4, lg: 4 }}>
                {/* Left Column - MainFamilyInfo + NavChart */}
                <Grid item xs={12} lg={7}>
                    <Grid container spacing={2} direction="column" sx={{ gap: { xs: '1rem', lg: '2rem' } }}>
                        <Grid item xs={12}>
                            <MainFamilyInfo familyData={familyData} familyDataLoading={isFamilyDataLoading} />
                        </Grid>
                        <Grid item xs={12}>
                            <FamilyBenchmarkChart
                                isLoading={familyBenchmarkLoading}
                                getAllData={familyBenchmarkData?.result}
                                dynamicY={true}
                                success={familyBenchmarkData?.isSuccess}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {/* Right Column - Two Pie Charts */}
                <Grid item xs={12} lg={5}>
                    <Grid container spacing={2} direction="column" sx={{ gap: { xs: '1rem', lg: '2rem' } }}>
                        <Grid item xs={12}>
                            <Box
                                sx={(theme: Theme) => ({
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.white}0D`,
                                    padding: {
                                        xs: '1.25rem 1.5rem 2rem 1.5rem',
                                        md: '1.5625rem 1.875rem 1.8125rem 1.875rem'
                                    },
                                    borderRadius: '0.9375rem',
                                    height: '100%',
                                    minHeight: '25.25rem',
                                    display: 'flex',
                                    flexDirection: 'column'
                                })}
                            >
                                <Typography
                                    variant="h2"
                                    sx={(theme: Theme) => ({
                                        letterSpacing: "0.01px",
                                        color: theme.palette.text.primary,
                                        mb: '1.5rem',
                                        mt: 0
                                    })}
                                >
                                    Family Distribution
                                </Typography>
                                {!isFamilyDataLoading && !familyData?.familyDistribution?.data?.length ?
                                    <ErrorText /> :
                                    <CustomePieChart
                                        title="Family Distribution"
                                        isLoading={isFamilyDataLoading}
                                        data={familyData?.familyDistribution?.data}
                                        labelData={familyData?.familyDistribution?.labelData}
                                        totalValue={familyData?.familyDistribution?.totalValue}
                                        showSlider
                                    />
                                }
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={(theme: Theme) => ({
                                    backgroundColor: theme.palette.common.white,
                                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.white}0D`,
                                    padding: {
                                        xs: '1.25rem 1.5rem 2rem 1.5rem',
                                        md: '1.5625rem 1.875rem 1.8125rem 1.875rem'
                                    },
                                    borderRadius: '1.25rem',
                                    height: '100%',
                                    minHeight: '25.25rem',
                                    display: 'flex',
                                    flexDirection: 'column'
                                })}
                            >
                                <Typography
                                    variant="h2"
                                    sx={(theme: Theme) => ({
                                        letterSpacing: "0.01px",
                                        color: theme.palette.text.primary,
                                        mb: '1.5rem',
                                        mt: 0
                                    })}
                                >
                                    Asset Allocation
                                </Typography>
                                {!familyAssetLoading && !familyAssetData?.result?.data?.length ?
                                    <ErrorText />
                                    : <CustomePieChart
                                        title="Asset Allocation"
                                        isLoading={familyAssetLoading}
                                        data={familyAssetData?.result?.data}
                                        labelData={familyAssetData?.result?.labelData}
                                        totalValue={familyAssetData?.result?.totalValue}
                                        showSlider
                                    />
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>


            {/* Family Info */}
            <Grid container spacing={2} sx={{ mt: 3 }}>
                {familyMembersData?.result?.map((member, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        lg={4}
                        key={member?.customer || index}
                    >
                        <FamilyInfo
                            columnWidth={{ xs: 12, sm: 12, lg: 12 }} // Full width of its Grid item
                            personName={member?.customerName}
                            isAdmin={false}
                            personDesignation={member?.isFamilyHead === 'Y' ? 'Family Head' : ''}
                            investmentValue={member?.bookCost}
                            currentValue={member?.marketValue}
                            overallReturns={member?.customerReturns}
                            irr={member?.customerReturnPercentage}
                            loading={isFamilyDataLoading}
                            handleNavigation={handleClickEvent}
                            clientCode={member?.customer}
                            showRemoveIcon={member?.isFamilyHead === 'N'}
                            isRmLoggedIn={isRmLoggedIn}
                            onRemoveMember={handleRemoveMember}
                            isRemove={isRemove}
                        />
                    </Grid>
                ))}
            </Grid>

            {/* OTP Form */}
            <Dialog
                open={otpDialogOpen}
                onClose={handleCloseOtpDialog}
                sx={(t: Theme) => ({
                    '& .MuiPaper-root': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: 530,
                        maxWidth: '100%',
                        padding: '24px',
                        borderRadius: '12px',
                        background: '#FFF',
                        boxShadow: `0px 4px 10px 0px ${t.palette.common.black}0D`,
                    },
                })}
            >
                <DialogContent sx={{ width: '100%' }}>
                    <OTPForm
                        onSubmit={handleSubmit}
                        onResend={handleResendOtp}
                        otpMessage={otpMessage}
                        warningMessage=""
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}
